<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row justify-content-sm-start justify-content-center">
      <div class="col-xl-3 col-lg-4 d-flex justify-content-center">
        <el-form-item
          :label="L10n('photo')"
          prop="thumbnailPath"
          data-filed="true"
          class="material-style">
          <br/>
          <image-uploader
            style="width: 16rem"
            :model.sync="form.thumbnailPath"
            :rounded="true"
            :label="L10n('change-photo')"/>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('firstName')"
          prop="firstName"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.firstName"
            @input="form.firstName = valueTrimLeft($event)"/>
        </el-form-item>
        <el-form-item
          :label="L10n('lastName')"
          prop="lastName"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            :value="form.lastName"
            @input="form.lastName = valueTrimLeft($event)"
            @change="updateModelItem('lastName', { required: true })"
          />
        </el-form-item>
        <el-form-item
          :label="L10n('user-path')"
          prop="userPath"
          class="material-style">
          <el-input
            :value="form.userPath"
            @input="form.userPath = valueTrimLeft($event)"
            @change="updateModelItem('userPath')"
          />
        </el-form-item>
        <el-form-item
          :label="L10n('email-display-name')"
          prop="emailDisplayName"
          :rules="getValidationRule('minLength')"
          class="material-style"
        >
          <el-input
            :value="form.emailDisplayName"
            @input="form.emailDisplayName = valueTrimLeft($event)"
            @change="updateModelItem('emailDisplayName')"
          ></el-input>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('smtp-host')"
          :rules="getValidationRule('minLength')"
          prop="smtpHost"
          class="material-style"
        >
          <el-input
            :value="form.smtpHost"
            @input="form.smtpHost = valueTrimLeft($event)"
            @change="updateModelItem('smtpHost')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="L10n('smtp-port')"
          :rules="getValidationRule('numberInteger')"
          prop="smtpPort"
          class="material-style"
        >
          <el-input
            :value="form.smtpPort"
            @input="form.smtpPort = valueNumber($event)"
            @change="updateModelItem('smtpPort')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="L10n('smtp-password')"
          prop="smtpPassword"
          class="material-style"
        >
          <el-input
            :value="form.smtpPassword"
            @input="form.smtpPassword = valueTrimLeft($event)"
            @change="updateModelItem('smtpPassword')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="L10n('employee')"
          prop="employeeID"
          :rules="getValidationRule('requiredSelect')"
          class="material-style">
          <select-response
            :model.sync="form.employeeID"
            @update:model="updateModelItem('smtpPassword', { required: true })"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.isLoading"
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-6 col-12">
        <el-form-item
          :label="L10n('email-signature')"
          prop="emailSignature"
          :rules="getValidationRule('minLength')"
          class="material-style"
        >
          <skill-editor
            :model.sync="form.emailSignature"
            @blur="updateModelItem('emailSignature')"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormProfile',
  components: {
    'skill-editor': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/SkillEditor')
  },
  mixins: [Form],
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    }
  }
}
</script>
